<template>
	<div class="product">
		<div class="search-order">
			<div class="el-search vue-top-padding radius">
				<el-row :gutter="20">
					<el-col :span="3">
						<div class="el-left">
							<el-button
								size="small"
								icon="el-icon-printer"
								@click="exportOrder"
								>{{ $t("common.export") }}</el-button
							>
						</div>
					</el-col>
					<el-col :span="21">
						<div class="el-right">
							<el-form
								ref="order"
								:model="search"
								:inline="true"
								label-width="10px"
								size="small"
								class="demo-form-inline el-input-height"
							>
								<el-form-item prop="dateTime">
									<el-date-picker
										v-model="dateTime"
										type="datetimerange"
										format="yyyy-MM-dd HH:mm:ss"
										value-format="yyyy-MM-dd HH:mm:ss"
										range-separator="-"
										:start-placeholder="$t('searchOrder.start')"
										:end-placeholder="$t('searchOrder.end')"
									>
									</el-date-picker>
								</el-form-item>
								<el-form-item prop="equipmentNo">
									<el-input
										v-model="search.equipmentNo"
										:placeholder="$t('searchRenewalRecord.equipmentNo')"
									></el-input>
								</el-form-item>
								<el-form-item prop="orderNumber">
									<el-input
										v-model="search.orderNumber"
										:placeholder="$t('helpcenter.orderNumber')"
									></el-input>
								</el-form-item>
								<el-form-item prop="phone">
									<el-input
										v-model="search.phone"
										:placeholder="$t('helpcenter.lianxifangshi')"
									></el-input>
								</el-form-item>
								<el-form-item prop="type">
									<el-select
										v-model="search.type"
										:no-data-text="$t('common.noData')"
										:no-match-text="$t('common.noData')"
										clearable
										:placeholder="$t('helpcenter.xzfklx')"
									>
										<el-option
											v-for="item in feedbackTypeList"
											:key="item.id"
											:label="item.label"
											:value="item.value"
										></el-option>
									</el-select>
								</el-form-item>
								<el-form-item prop="state">
									<el-select
										v-model="search.state"
										:no-data-text="$t('common.noData')"
										:no-match-text="$t('common.noData')"
										clearable
										:placeholder="$t('helpcenter.xzstatus')"
									>
										<el-option
											v-for="item in feedbackStateList"
											:key="item.id"
											:label="item.label"
											:value="item.value"
										></el-option>
									</el-select>
								</el-form-item>
								<el-form-item>
									<el-button
										type="primary"
										@click="onSubmit"
										icon="el-icon-search"
										>{{ $t("common.search") }}</el-button
									>
									<el-button @click="resetSearch()" icon="el-icon-refresh">{{
										$t("common.reset")
									}}</el-button>
								</el-form-item>
							</el-form>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="vue-padding radius">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="feedbackList"
				style="width: 100%"
				max-height="638"
				:border="true"
			>
				<el-table-column
					prop="sort"
					:label="$t('menu.sort')"
					width="90"
					:align="'center'"
					:show-overflow-tooltip="true"
				></el-table-column>
				<el-table-column
					prop="userName"
					:label="$t('user.userName')"
					width="150"
					:align="'center'"
					:show-overflow-tooltip="true"
				></el-table-column>
				<el-table-column
					prop="nickName"
					:label="$t('user.nickName')"
					width="150"
					:align="'center'"
					:show-overflow-tooltip="true"
				></el-table-column>
				<el-table-column
					prop="type"
					:label="$t('helpcenter.fklx')"
					width="150"
					:align="'center'"
					:formatter="funcFeedbackType"
				></el-table-column>
				<el-table-column
					prop="content"
					:label="$t('helpcenter.wentimiaoshu')"
					:align="'center'"
					:show-overflow-tooltip="true"
				></el-table-column>
				<el-table-column
					prop="equipmentNo"
					:label="$t('helpcenter.sbbh')"
					width="170"
					:align="'center'"
					:show-overflow-tooltip="true"
				></el-table-column>
				<el-table-column
					prop="orderNumber"
					:label="$t('helpcenter.orderNumber')"
					width="170"
					:align="'center'"
					:show-overflow-tooltip="true"
				></el-table-column>
				<el-table-column
					prop="phone"
					:label="$t('helpcenter.lianxifangshi')"
					width="155"
					:align="'center'"
					:show-overflow-tooltip="true"
				></el-table-column>
				<el-table-column
					prop="createTime"
					:label="$t('helpcenter.createtime')"
					width="150"
					:align="'center'"
				></el-table-column>
				<el-table-column
					fixed="right"
					:label="$t('helpcenter.status')"
					:width="$i18n.locale == 'zh_CN' ? 235 : 285"
					:align="'center'"
				>
					<template slot-scope="scope">
						<template v-if="scope.row.state == 0">
							<el-button
								type="warning"
								size="mini"
								v-hasPerm="['helpcenter:download']"
								@click="handleDownload(scope.row)"
								>{{ $t("helpcenter.xzfj") }}</el-button
							>
							<el-button
								type="primary"
								size="mini"
								v-hasPerm="['helpcenter:confirm']"
								@click="handleConfirm(scope.row)"
								>{{ $t("helpcenter.confirm") }}</el-button
							>
							<el-button
								type="danger"
								@click="handleDeletes(scope.row)"
								size="mini"
								v-hasPerm="['helpcenter:deletes']"
								>{{ $t("helpcenter.deletes") }}</el-button
							>
						</template>
						<template v-else>
							<el-button
								type="warning"
								size="mini"
								v-hasPerm="['helpcenter:download']"
								@click="handleDownload(scope.row)"
								>{{ $t("helpcenter.xzfj") }}</el-button
							>
							<el-button
								type="danger"
								@click="handleDeletes(scope.row)"
								size="mini"
								v-hasPerm="['helpcenter:deletes']"
								>{{ $t("helpcenter.deletes") }}</el-button
							>
							<el-tag size="big" type="success" style="margin-left: 10px;">{{
								$t("helpcenter.done")
							}}</el-tag>
						</template>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				v-if="page.totalSize > 0"
				background
				layout="prev, pager, next"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@current-change="currentChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
export default {
	name: "Record",
	components: {},
	data() {
		return {
			feedbackTypeList: [],
			feedbackStateList: [],
			dateTime: "",
			search: {
				startTime: "",
				endDate: "",
				equipmentNo: "",
				orderNumber: "",
				phone: "",
				type: "",
				state: "",
			},
			loading: false,
			page: {
				pageSize: 10,
				pageIndex: 1,
				totalSize: 0,
			},
			feedbackList: [],
		};
	},
	mounted() {
		this.getFeedbackType();
		this.getFeedbackStatus();
		this.currentChange();
	},
	methods: {
		// 确认已处理
		handleConfirm(row) {
			let _self = this;
			this.$confirm(this.$t("helpcenter.confirmtip"), this.$t("common.tip"), {
				confirmButtonText: this.$t("common.definite"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			})
				.then(() => {
					let obj = {
						id: row.id,
						state: 1,
					};
					_self.$api
						.request(_self.$url.Feedback.update, _self.$method.put, obj)
						.then(res => {
							if (res.code === 0) {
								this.$notify({
									title: this.$t("common.tip"),
									message: res.msg,
									type: "success",
								});
								let djs = setTimeout(function() {
									clearTimeout(djs);
									window.location.reload();
								}, 800);
							}
						})
						.catch(() => {});
				})
				.catch(() => {});
		},
		// 删除反馈
		handleDeletes(row) {
			let _self = this;
			this.$confirm(this.$t("helpcenter.deletestip"), this.$t("common.tip"), {
				confirmButtonText: this.$t("common.definite"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			})
				.then(() => {
					let obj = {
						id: row.id,
					};
					_self.$api
						.request(_self.$url.Feedback.deletes, _self.$method.delete, obj)
						.then(res => {
							if (res.code === 0) {
								this.$notify({
									title: this.$t("common.tip"),
									message: res.msg,
									type: "success",
								});
								let djs = setTimeout(function() {
									clearTimeout(djs);
									window.location.reload();
								}, 800);
							}
						})
						.catch(() => {});
				})
				.catch(() => {});
		},
		// 下载附件
		handleDownload(row) {
			let _self = this;
			let filestr = "";
			let files = row.files;
			for (let i = 0; i < files.length; i++) {
				let dstr =
					files[i]["name"] +
					' <a href="' +
					files[i]["url"] +
					'" target="_blank">' +
					this.$t("helpcenter.dwxz") +
					"</a>";
				if (filestr == "") {
					filestr = dstr;
				} else {
					filestr = "<br>" + dstr;
				}
			}
			_self.$alert(filestr, this.$t("helpcenter.xztip"), {
				dangerouslyUseHTMLString: true,
			});
		},
		// 获取反馈类型
		getFeedbackType() {
			this.$api.dict("feedback_type").then(res => {
				if (res.code === 0) {
					this.feedbackTypeList = res.data;
				}
			});
		},
		// 获取反馈状态
		getFeedbackStatus() {
			this.$api.dict("feedback_state").then(res => {
				if (res.code === 0) {
					this.feedbackStateList = res.data;
				}
			});
		},
		// 格式化反馈类型
		funcFeedbackType(row) {
			return this.$cloud.getDictLabel(this.feedbackTypeList, row.type);
		},
		// 格式化反馈状态
		funcFeedbackState(row) {
			return this.$cloud.getDictLabel(this.feedbackStateList, row.state);
		},
		// 加载反馈列表
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.Feedback.page, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.feedbackList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		// 提交查询搜索
		onSubmit() {
			if (this.dateTime && this.dateTime.length > 0) {
				this.search.startTime = this.dateTime[0];
				this.search.endDate = this.dateTime[1];
			} else {
				this.search.startTime = "";
				this.search.endDate = "";
			}
			this.page.pageIndex = 1;
			this.currentChange();
		},
		// 重置条件
		resetSearch() {
			this.dateTime = "";
			this.search.startTime = "";
			this.search.endDate = "";
			this.search.equipmentNo = "";
			this.search.orderNumber = "";
			this.search.phone = "";
			this.search.type = "";
			this.search.state = "";
			this.currentChange();
		},
		// 导出账单
		exportOrder() {
			this.$confirm(this.$t("helpcenter.export"), this.$t("common.tip"), {
				confirmButtonText: this.$t("common.definite"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			})
				.then(() => {
					this.$api.download(this.$url.Feedback.export, this.search);
				})
				.catch(err => {
					this.$message.error(err.msg);
				});
		},
	},
};
</script>
